import React from "react";
import ItemBar from "./ItemBar";

interface BarProps {
  lengthList: number;
  itemList: JSX.Element[];
}

export default function Bar(props: BarProps) {
  return (
    <div className="bar">
      {props.itemList.map((item, index) => {
        return (
          <ItemBar key={index} value={item} lengthList={props.lengthList} />
        );
      })}
    </div>
  );
}
